import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Preloader from "../../components/Preloader";
import { MarcasService } from "../../services/MarcasService";
import "./NuevoMarca.css";
import { AuthContext } from "../../context/AuthContext";

const NuevoMarca = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({ descripcion: "", estado: "ACTIVO" });
  const [imagen, setImagen] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [errores, setErrores] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagen(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleBackToList = () => {
    navigate("/admin/marcas");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errores = validarFormulario();
    if (Object.keys(errores).length > 0) {
      setErrores(errores);
      return;
    }
    setLoading(true);
    try {
      await MarcasService.registrarMarca({ token, form, imagen });
      toast.success("Marca registrada correctamente");
      setForm({ descripcion: "", estado: "ACTIVO" });
      setImagen(null);
      setPreview(null);
      navigate("/admin/marcas");
    } catch (err) {
      setError("");
      if (err.response?.status === 409) {
        toast.error(err.response.data.error);
      } else {
        toast.error("Error al registrar la marca.");
      }
    } finally {
      setLoading(false);
    }
  };

  const validarFormulario = () => {
    const errores = {};
    if (!form.descripcion.trim()) {
      errores.descripcion = "La descripción es obligatoria";
    }
    return errores;
  };

  return (
    <div className="ventas-admin-content">
      {loading && <Preloader />}
      <div className="breadcrumb-container">
        <button type="button" className="breadcrumb-link" onClick={handleBackToList} style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "var(--color-primary)", textDecoration: "underline", font: "inherit" }}>
          {"\u2190"} Listado de Marcas
        </button>
        <span className="breadcrumb-current"> / Registrar Marca</span>
      </div>
      <div className="dashboard-card nuevo-producto-card">
        <span className="nueva-venta-title">Registrar Marca</span>
        <form className="nuevo-producto-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <h3 className="section-title">Información de la Marca</h3>
            <div className="form-grid">
              <div className="form-group large">
                <label htmlFor="descripcion">Descripción *</label>
                <input
                  type="text"
                  name="descripcion"
                  value={form.descripcion}
                  onChange={handleChange}
                  placeholder="Ej: Nike, Adidas, Puma"
                />
                {errores.descripcion && <span className="error">{errores.descripcion}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="estado">Estado *</label>
                <select name="estado" value={form.estado} onChange={handleChange}>
                  <option value="ACTIVO">ACTIVO</option>
                  <option value="INACTIVO">INACTIVO</option>
                </select>
              </div>
              <div className="form-group large">
                <label htmlFor="imagen">Imagen de la Marca</label>
                <div className="image-upload-container">
                  <input
                    type="file"
                    name="imagen"
                    id="imagen"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="image-upload-input"
                  />
                  {preview && (
                    <div className="image-preview-logo">
                      <img src={preview} alt="Preview" />
                      <button
                        className="image-remove-btn"
                        onClick={() => {
                          setPreview(null);
                          setImagen(null);
                        }}
                      >
                        ×
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {error && <div className="error-message">{error}</div>}
          <div className="form-actions">
            <button
              className="btn btn-secondary"
              type="button"
              onClick={() => setForm({ descripcion: "", estado: "ACTIVO" })}
            >
              Limpiar Formulario
            </button>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? "Registrando..." : "Registrar Marca"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NuevoMarca;
